import { render, staticRenderFns } from "./NoteWidgetComponent.vue?vue&type=template&id=f5903360&"
import script from "./NoteWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./NoteWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports